module.exports = __webpack_public_path__ + "static/media/sol.5ca03cc7.jpg";